/** Temporary demo card pool — replaced by extracted JSON in Phase 4. */
export const DEMO_BLACK_CARDS = [
  'The highlight of my weekend was _________.',
  'Why can\'t I sleep at night?',
  'The secret to a long, happy marriage is simple: _________.',
  'What would grandma find disturbing, yet oddly charming?',
  'During the meeting, everyone was shocked by _________.',
];

export const DEMO_WHITE_CARDS = [
  'A suspicious casserole.',
  'Unexpected jazz hands.',
  'A disappointing plot twist.',
  'Mystery leftovers from Tuesday.',
  'Aggressive interpretive dance.',
  'The smell of regret.',
  'An oversized wet sponge.',
  'Existential dread at 3 AM.',
  'A gluten-free apocalypse.',
  'Accidentally starting a cult.',
  'Unrelenting eye contact.',
  'A very long spreadsheet.',
  'A really big, wet sneeze.',
  'Leaving at the altar.',
  'Being too attractive for my own good.',
];

export const DEMO_BOT_ANSWERS = [
  'Aggressive interpretive dance.',
  'Unrelenting eye contact.',
  'A very long spreadsheet.',
  'A really big, wet sneeze.',
  'Leaving at the altar.',
  'Tapping on a window.',
  'Crying in a limousine.',
];

export const PLAYER_GRADIENTS = [
  'from-primary-container to-primary/60',
  'from-secondary-container to-secondary/40',
  'from-tertiary-container to-tertiary/40',
  'from-surface-variant to-surface-container-high',
  'from-primary/40 to-secondary/30',
  'from-tertiary/40 to-primary/30',
];

export const DEMO_BOTS = [
  { name: 'NeonViper', gradient: PLAYER_GRADIENTS[1]! },
  { name: 'ShadowByte', gradient: PLAYER_GRADIENTS[2]! },
];
